export default __webpack_public_path__ + "static/4-f514e27b6edc0fd21409219b51823bcd.jpeg";